<template>
  <div>
    <v-img
      v-if="isWithUploadedImage"
      :src="elementData.public_link"
    />
    <v-img
      v-if="isWithCroppedImage"
      :src="elementData.cropped"
    />
    <v-file-input
      ref="imagefileinput"
      v-if="isEmptyImageElement"
      v-model="file"
      :loading="isLoading"
      accept=".png, .jpg"
      label="Click here to upload image"
      @change="callCropperDialog"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RowElementImage',
  components: {
  },

  props: {
    elementData: {
      type: Object,
    },

    elementIndex: {
      type: Number,
    },

    rowIndex: {
      type: Number,
    },
  },

  data: () => ({
    file: null,
    isLoading: false,
    previewFileStr: null,
  }),

  methods: {
    ...mapActions({
      updateElement: 'microsite/updateElement',
      openCropperDialog: 'micrositeCropperDialog/openCropperDialog',
      setInputImageUrl: 'micrositeCropperDialog/setInputImageUrl',
      setRowIndex: 'micrositeCropperDialog/setRowIndex',
      setElementIndex: 'micrositeCropperDialog/setElementIndex',
      setAspectRatio: 'micrositeCropperDialog/setAspectRatio',
    }),

    setCroppedImageStr(croppedImageStr = '') {
      const element = JSON.parse(
        JSON.stringify(this.elementData),
      );

      element.cropped = croppedImageStr;

      this.updateElement({
        rowIndex: this.rowIndex,
        elementIndex: this.elementIndex,
        newElementData: element,
      });
    },

    callCropperDialog() {
      if (!this.file) {
        return;
      }

      const aspectRatio = this.rowLength(this.rowIndex) === 1
        ? 'horizontal'
        : 'vertical';

      this.setAspectRatio(aspectRatio);

      this.setInputImageUrl(URL.createObjectURL(this.file));

      this.setRowIndex(this.rowIndex);
      this.setElementIndex(this.elementIndex);
      this.openCropperDialog();
    },
  },

  computed: {
    ...mapGetters({
      rowLength: 'microsite/rowLength',
    }),

    isEmptyImageElement() {
      return !this.isWithCroppedImage && !this.isWithUploadedImage;
    },

    isWithCroppedImage() {
      return !!this.elementData.cropped;
    },

    isWithUploadedImage() {
      return !!this.elementData.public_link;
    },
  },
};
</script>

<style scoped>
</style>
